import Custom from './custom'

export default {
  Custom,
}
